export enum TabAction {
  Add = 'add',
  Remove = 'remove'
}
